<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br />
    <span>{{ "LBL_CONSULTANDO" | translate }}</span>
  </div>
</div>

<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12">
      <p-panel header="{{ 'POLITICASDURAS.LBL_CRITERIOS' | translate }}" *ngIf="politicaDura">
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label"
            >{{ "POLITICASDURAS.LBL_POLITICAS" | translate }}:</label
          >
          <label class="lg:col-3 col-6 md:col-8"
            ><strong>{{ politicaDura.tipoPoliticaDura }}</strong></label
          >
          <label class="lg:col-3 col-6 md:col-4 control-label"
            >{{ "POLITICASDURAS.LBL_PARAMETROS" | translate }}:</label
          >
          <label class="lg:col-3 col-6 md:col-8"
            ><strong>{{
              politicaDura.parametro
                ? politicaDura.parametro
                : politicaDura.tipoDocumento
                ? politicaDura.tipoDocumento
                : politicaDura.camino
                ? politicaDura.camino
                : null
            }}</strong></label
          >
        </div>
      </p-panel>
    </div>
  </div>

  <div *ngIf="politicaDura && politicaDura.codigotipoPoliticaDura === 'CIUNAPLI'">
    <div class="grid">
      <div class="col-12 md:col-6 lg:col-6">
      </div>
      <div class="col-12 md:col-6 lg:col-6">
        <input #gb type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
                (input)="dt.filterGlobal($event.target.value, 'contains')"
                [(ngModel)]="busqueda" (change)="setSearch()">
      </div>
    </div>
    <div class="grid">
      <div class="col-12 md:col-12 lg:col-12">
        <p-table
          [columns]="columnas"
          [loading]="carPoliticasDuras"
          #dt
          [value]="politicasDurasDivisionesPoliticas"
          selectionMode="single"
          dataKey="idPoliticasDuras"
          [paginator]="true"
          [rows]="10"
          paginatorPosition="bottom"
        >
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th
                *ngFor="let col of columns"
                [pSortableColumn]="col.field"
                [pSortableColumnDisabled]="!col.sort"
                class="text-center"
              >
                {{ col.header }}
                <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr [pSelectableRow]="row">
              <td>{{ row.camino }}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length" class="text-center">
                {{ "MSG_NOHAYREGISTROS" | translate }}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>

  <div class="grid form-footer-buttons">
    <div class="form-group col-12">
      <button
        icon="fa fa-arrow-left"
        label="{{ 'BTN_REGRESAR' | translate }}"
        type="button"
        pButton
        (click)="regresar()"
      ></button>
    </div>
  </div>
</div>
